// 用户中心-老带新推荐操作
const UserRecommendRouterMap = [
  {
    path: '/user/invite',
    component: Invite => (require(['@/views/recommend/invite'], Invite))
  },
  {
    path: '/recommend/invite',
    component: Invite => (require(['@/views/recommend/invite'], Invite))
  },
  {
    path: '/recommend/invite-new',
    component: Invitetonew => (require(['@/views/recommend/inviteNewcomer'], Invitetonew))
  },
  {
    path: '/recommend/invite-success',
    component: InviteSuccess => (require(['@/views/recommend/inviteSuccess'], InviteSuccess))
  },
  {
    path: '/recommend/invite-coupon',
    component: InviteCoupon => (require(['@/views/recommend/inviteCoupon'], InviteCoupon))
  },
  {
    path: '/recommend/redirect',
    component: Redirect => (require(['@/views/recommend/redirect'], Redirect))
  },
  {
    path: '/redirect',
    component: Redirect => (require(['@/views/recommend/redirect'], Redirect))
  },
  {
    path: '/recommend/weclome',
    component: InviteWeclome => (require(['@/views/recommend/inviteWeclome'], InviteWeclome))
  },
  {
    path: '/recommend/invite-success-final',
    component: InviteSuccessFinal => (require(['@/views/recommend/inviteSuccessFinal'], InviteSuccessFinal))
  },
  {
    path: '/recommend/invite-by-wechatmini',
    component: Invite => (require(['@/views/recommend/inviteVipWechatMini'], Invite))
  },
  {
    path: '/recommend/invite-by-wechatminixcw',
    component: Invite => (require(['@/views/recommend/inviteVipWechatMini'], Invite))
  },
  {
    path: '/user/invite-rule',
    component: Invite => (require(['@/views/recommend/inviteRule'], Invite))
  },
  // 用户微信登陆页面
  {
    path: '/user/wechat-login',
    component: Welogin => (require(['@/views/recommend/wechatLogin'], Welogin))
  }
]

export default UserRecommendRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/recommend.js